import { connect } from 'react-redux';
import React from 'react';
import { compose, hoistStatics, withHandlers, defaultProps } from 'recompose';
import { translate, Trans } from 'react-i18next';
import { toast } from 'react-toastify';
import ImportFile from './ImportFile';
import { uploadSelectors } from '../../../../reducers/upload';

const fileSelector = uploadSelectors.getTempFile('importFile');

const mapStateToProps = state => ({
  importFile: fileSelector(state),
});

const enhance = compose(
  connect(mapStateToProps, null),
  translate('core'),
  defaultProps({
    extensions: ['xls', 'xlsx'],
  }),
  withHandlers({
    afterUploadingFile: props => async (tempFile) => {
      const { service, afterImport } = props;
      if (tempFile.id) {
        const result = await service.sendImportFile({ file_id: tempFile.id });
        if (result.success) {
          toast.success((<Trans>The import is in progress</Trans>));
          if (afterImport)afterImport(1);
        } else {
          toast.error((<Trans>Something went wrong, please try again later</Trans>));
          if (afterImport)afterImport(0);
        }
      } else if (tempFile && tempFile.message && tempFile.uploadingPc === 100) {
        toast.error((<Trans>{tempFile.message}</Trans>));
        if (afterImport)afterImport(0);
      }
    },
  }),
);

export default hoistStatics(enhance)(ImportFile);



// WEBPACK FOOTER //
// ./src/components/cms/form/importFile/index.js